// extracted by mini-css-extract-plugin
module.exports = {"comp":"Animation2_comp__FiPxG","title":"Animation2_title__y8FRj"};